<template>
  <div>
    <van-popup v-model="show" :close-on-click-overlay="false">
      <van-loading size="40" color="#fff"/>
    </van-popup>
  </div>
</template>

<script>
export default {
  data () {
    return {
      show: true
    }
  }
}
</script>

<style scoped lang="less">
/deep/ .van-overlay {
  background-color: rgba(0, 0, 0, 0);
}
.van-popup {
  background-color: #534b45;
  padding: 20px;
  border-radius: 15px;
}
</style>
